import { WebsiteModule } from '@/interfaces/module.interface';
import { ApiQueryParams, apiRequest } from '../Api';

export interface ReadWebsiteModuleResponse {
  success: boolean;
  message: string;
  data: WebsiteModule;
}

export const readWebsiteModule = (
  moduleId: string,
  params: ApiQueryParams
) =>
  apiRequest<void, ReadWebsiteModuleResponse>({
    url: `/entities/read/${moduleId}`,
    scope: 'module',
    method: 'GET',
    params,
  });

